var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contact" },
    [
      _c(
        "content-wrapper-block",
        [
          _c("page-title", { attrs: { white: "" } }, [_vm._v(" контакты ")]),
          _c(
            "div",
            { staticClass: "contact-items" },
            [
              _c(
                "card-adress",
                {
                  attrs: {
                    title: "Квартал MAINSTREET",
                    address: _vm.buildingAddress,
                    "work-time": _vm.buildingWorkTime,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "icon" },
                    [_c("icon-location", { attrs: { color: "#E14313" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "card-adress",
                {
                  attrs: {
                    title: "офис продаж",
                    address: _vm.ofiiceAddress,
                    "work-time": _vm.officeWorkTime,
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "icon" },
                    [_c("icon-location", { attrs: { color: "#83B4FF" } })],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "contact-map" }, [_c("Map")], 1),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }